<script>
    import { fade, fly } from 'svelte/transition';

    export let profile;
    let totalDurationName = profile.name.length * 100
</script>


<div class="informations-container">
					
    <div class="informations-profile">
        <div class="informations-name">
            {#each profile.name as char, i}
                <strong in:fade="{{delay: 800 + i*100, duration: 200 }}">{char}</strong>
            {/each}
        </div>
        <div class="informations-title" in:fly="{{delay: 800 + totalDurationName, duration: 500, y: 50}}">
            <strong >{profile.title}</strong>
        </div>
    </div>
    <div class="informations-data-container">
        {#each profile.data as data, i}
            <div in:fly="{{delay: 800 + totalDurationName + 500 + i*200, duration: 300, x: 50 }}" class="informations-data">
                <a target="_blank" href={data.link}>
					<img alt="Icon data" src={data.icon}/>
					{data.value}
				</a>
            </div>
        {/each}
    </div>
</div>


<style>
    .informations-container {
		flex-grow: 1;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: baseline;
	}

	.informations-profile {
		padding-left: 5%;
		text-align: start;
	}

	.informations-name {
		color: var(--color-primary);
		font-size: 8vw;
		
	}

	.informations-title {
		color: var(--color-grey);
		font-size: 4vw;
		padding-top: 4%;
		padding-bottom: 4%;
		overflow: visible;
	}

	.informations-data-container {
		margin-right: 3%;
		padding-left: 5%;
		width: fit-content;
	}

	.informations-data {
		padding: 1%;
		color: var(--color-grey);
		font-size: 3vw;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		white-space: nowrap;
	}

	.informations-data > a {
		display: flex;
		align-items: center;
		color: var(--color-grey) !important;
		text-decoration: none;
		gap: 5px;
	}

	.informations-data > a > img {
		width: 4vw;
	}

	@media only screen and (max-width: 768px) {
		.informations-container > * {
			flex-grow: 1;
		}
	}
	@media only screen and (min-width: 768px) {

        .informations-name {
            font-size: 4vw;
        }

        .informations-title {
            font-size: 2vw;
        }

        .informations-data {
            font-size: 1.5vw;
        }

        .informations-data > a  > img {
            width: 2vw;
        }
    }

	@media only screen and (min-width: 1850px) {

		.informations-name {
			font-size: 70px;
		}

		.informations-title {
			font-size: 35px;
		}

		.informations-data {
			font-size: 25px;
		}

		.informations-data > a {
			gap: 8px;
		}

		.informations-data > a  > img {
			width: 2vw;
		}
	}

</style>